import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';

const getCurrentServicesQuery = graphql(`
  query currentServices {
    contactCenters {
      items {
        id
        name
      }
    }
  }
`);

async function getCurrentServices(fetchOptions?: RequestInit) {
  const { data, error } = await getClient().query({
    fetchPolicy: 'network-only',
    query: getCurrentServicesQuery,
    ...(fetchOptions && { context: { fetchOptions } }),
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.contactCenters?.items ?? [];
}

export default getCurrentServices;
